import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { HeaderService } from '../../service/header.service';
import { AuthService } from '../../../shared/services/auth/auth.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-meu-perfil',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './meu-perfil.component.html',
  styleUrls: ['./meu-perfil.component.scss'],
})
export class MeuPerfilComponent implements OnInit {
  BASE_IMG_URL: string = environment.BASE_IMG_URL;
  nomeUsuario: string = '';
  emailUsuario: string = '';

  constructor(
    private headerService: HeaderService,
    private authService: AuthService,
  ) {}

  ngOnInit() {
    this.loadProfileData();
  }

  loadProfileData() {
    const companyID = this.authService.companyID;
    const restrictionKey = this.authService.restrictionKey;

    this.headerService.listProfileData(companyID, restrictionKey).subscribe(
      (response: any) => {
        if (response && response.data) {
          this.nomeUsuario = response.data.name || '';
          this.emailUsuario = response.data.email || '';
        }
      },
      (error) => {
        console.error('Erro ao carregar dados do perfil:', error);
      },
    );
  }
} 
